export var navigateTo = function (redirectPath) {
    if (typeof location !== 'undefined') {
        var baseUrl = location.origin;
        location.href = "".concat(baseUrl).concat(redirectPath);
    }
};
